export type WidgetVersion = "1" | "2";

const PROD_ASSET_BASE = "https://public.notifyy-widget.pages.dev";

const WIDGET_ASSET_FILES: Record<WidgetVersion, { js: string; css: string }> = {
  "1": { js: "widget-1.js", css: "widget-1.css" },
  // Planned: add `whatsappWidget/public/widget-2.js` + `widget-2.css`
  "2": { js: "widget-2.js", css: "widget-2.css" },
};

export function getWidgetAssetUrls(version: WidgetVersion = "1"): {
  js: string;
  css: string;
} {
  const files = WIDGET_ASSET_FILES[version] ?? WIDGET_ASSET_FILES["1"];

  if (import.meta.env.DEV) {
    const origin =
      typeof window !== "undefined" ? window.location.origin : "http://localhost:5174";
    return {
      js: `${origin}/${files.js}`,
      css: `${origin}/${files.css}`,
    };
  }

  return {
    js: `${PROD_ASSET_BASE}/${files.js}`,
    css: `${PROD_ASSET_BASE}/${files.css}`,
  };
}

